"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_core_1 = require("@patternfly/react-core");
const plus_circle_icon_1 = require("@patternfly/react-icons/dist/js/icons/plus-circle-icon");
const react_1 = tslib_1.__importDefault(require("react"));
const AddButton = (_a) => {
    var { onAdd, variant = react_core_1.ButtonVariant.link, children } = _a, props = tslib_1.__rest(_a, ["onAdd", "variant", "children"]);
    return (react_1.default.createElement(react_core_1.Button, Object.assign({ icon: react_1.default.createElement(plus_circle_icon_1.PlusCircleIcon, null), onClick: onAdd, variant: variant }, props), children));
};
exports.default = AddButton;
//# sourceMappingURL=AddButton.js.map